import { default as guidesiDXL2z1hTYMeta } from "/app/src/pages/guides.vue?macro=true";
import { default as help6sYsgUQJxrMeta } from "/app/src/pages/help.vue?macro=true";
import { default as indexdPwi6hPdMfMeta } from "/app/src/pages/index.vue?macro=true";
import { default as conditionsPJy6aUhvV6Meta } from "/app/src/pages/pokemon/conditions.vue?macro=true";
import { default as indexfwqDuucNzTMeta } from "/app/src/pages/pokemon/index.vue?macro=true";
import { default as promotionorXsQI4HXEMeta } from "/app/src/pages/pokemon/lp/promotion.vue?macro=true";
import { default as index0JJ8Fj4VGuMeta } from "/app/src/pages/pokemon/order/callback/index.vue?macro=true";
import { default as paypayWHppKBCzBEMeta } from "/app/src/pages/pokemon/order/callback/paypay.vue?macro=true";
import { default as complete8tejmvXXvXMeta } from "/app/src/pages/pokemon/order/complete.vue?macro=true";
import { default as index6mgBrI1WtSMeta } from "/app/src/pages/pokemon/order/index.vue?macro=true";
import { default as basic_45energiesRFWynnz2MLMeta } from "/app/src/pages/pokemon/pickups/basic-energies.vue?macro=true";
import { default as general_45purposewLcEjxPPlHMeta } from "/app/src/pages/pokemon/pickups/general-purpose.vue?macro=true";
import { default as sarguIUZngTkyMeta } from "/app/src/pages/pokemon/pickups/sar.vue?macro=true";
import { default as search9HcBfU6SgZMeta } from "/app/src/pages/pokemon/search.vue?macro=true";
import { default as index5y4LzYosyOMeta } from "/app/src/pages/pokemon/series/[seriesId]/index.vue?macro=true";
import { default as indexkydvw3BsqVMeta } from "/app/src/pages/pokemon/series/[seriesId]/packs/[packId]/index.vue?macro=true";
import { default as indexSJwVsZ7FrNMeta } from "/app/src/pages/pokemon/single/[inventoryProductId]/index.vue?macro=true";
export default [
  {
    name: "guides",
    path: "/guides",
    meta: guidesiDXL2z1hTYMeta || {},
    component: () => import("/app/src/pages/guides.vue")
  },
  {
    name: "help",
    path: "/help",
    meta: help6sYsgUQJxrMeta || {},
    component: () => import("/app/src/pages/help.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexdPwi6hPdMfMeta || {},
    component: () => import("/app/src/pages/index.vue")
  },
  {
    name: "pokemon-conditions",
    path: "/pokemon/conditions",
    meta: conditionsPJy6aUhvV6Meta || {},
    component: () => import("/app/src/pages/pokemon/conditions.vue")
  },
  {
    name: "pokemon",
    path: "/pokemon",
    meta: indexfwqDuucNzTMeta || {},
    component: () => import("/app/src/pages/pokemon/index.vue")
  },
  {
    name: "pokemon-lp-promotion",
    path: "/pokemon/lp/promotion",
    meta: promotionorXsQI4HXEMeta || {},
    component: () => import("/app/src/pages/pokemon/lp/promotion.vue")
  },
  {
    name: "pokemon-order-callback",
    path: "/pokemon/order/callback",
    meta: index0JJ8Fj4VGuMeta || {},
    component: () => import("/app/src/pages/pokemon/order/callback/index.vue")
  },
  {
    name: "pokemon-order-callback-paypay",
    path: "/pokemon/order/callback/paypay",
    meta: paypayWHppKBCzBEMeta || {},
    component: () => import("/app/src/pages/pokemon/order/callback/paypay.vue")
  },
  {
    name: "pokemon-order-complete",
    path: "/pokemon/order/complete",
    component: () => import("/app/src/pages/pokemon/order/complete.vue")
  },
  {
    name: "pokemon-order",
    path: "/pokemon/order",
    meta: index6mgBrI1WtSMeta || {},
    component: () => import("/app/src/pages/pokemon/order/index.vue")
  },
  {
    name: "pokemon-pickups-basic-energies",
    path: "/pokemon/pickups/basic-energies",
    meta: basic_45energiesRFWynnz2MLMeta || {},
    component: () => import("/app/src/pages/pokemon/pickups/basic-energies.vue")
  },
  {
    name: "pokemon-pickups-general-purpose",
    path: "/pokemon/pickups/general-purpose",
    meta: general_45purposewLcEjxPPlHMeta || {},
    component: () => import("/app/src/pages/pokemon/pickups/general-purpose.vue")
  },
  {
    name: "pokemon-pickups-sar",
    path: "/pokemon/pickups/sar",
    meta: sarguIUZngTkyMeta || {},
    component: () => import("/app/src/pages/pokemon/pickups/sar.vue")
  },
  {
    name: "pokemon-search",
    path: "/pokemon/search",
    meta: search9HcBfU6SgZMeta || {},
    component: () => import("/app/src/pages/pokemon/search.vue")
  },
  {
    name: "pokemon-series-seriesId",
    path: "/pokemon/series/:seriesId()",
    meta: index5y4LzYosyOMeta || {},
    component: () => import("/app/src/pages/pokemon/series/[seriesId]/index.vue")
  },
  {
    name: "pokemon-series-seriesId-packs-packId",
    path: "/pokemon/series/:seriesId()/packs/:packId()",
    meta: indexkydvw3BsqVMeta || {},
    component: () => import("/app/src/pages/pokemon/series/[seriesId]/packs/[packId]/index.vue")
  },
  {
    name: "pokemon-single-inventoryProductId",
    path: "/pokemon/single/:inventoryProductId()",
    meta: indexSJwVsZ7FrNMeta || {},
    component: () => import("/app/src/pages/pokemon/single/[inventoryProductId]/index.vue")
  }
]